<template>
  <v-form ref="form" v-model="isValid" class="pt-0" style="width: 100%;">
    <v-subheader class="pl-0">Query Details</v-subheader>

    <v-text-field :disabled="disabled" class="pt-2" :error-messages="errorMessages.name" :rules="[rules.required]" :counter="256" prepend-icon="label" required label="Name" v-model="formObject.name" persistent-hint hint="May want to include selection details (i.e. analyte, stations, or a date)" />

    <v-textarea :counter="512" :error-messages="errorMessages.description" :disabled="disabled" class="mt-4" label="Description" prepend-icon="comment" v-model="formObject.description" persistent-hint hint="Describe the purpose of this query" />

    <v-checkbox prepend-icon="date_range" :disabled="disabled" class="mt-4" v-model="hasRelativeDates" color="info" label="Relative dates" hide-details />
    <div class="ml-4 pl-2 pt-2 v-messages theme--light">
      <div v-if="hasRelativeDates">
        Date range is saved <strong>relative to view date</strong>. <br />
        To save exact dates, uncheck the box.
      </div>
      <div v-else>
        Date range is saved <strong>exactly as defined</strong>. <br />
        To save relatives dates, check the box.
      </div>
    </div>

    <v-checkbox prepend-icon="share" :disabled="disabled" class="mt-4" v-model="formObject.isShared" color="info" label="Share with others" :hint="formObject.isShared ? 'Users with access to the data can use this query, but cannot edit it' : 'Only you can use this query'" persistent-hint />

    <template v-if="isSomeAdmin">
      <v-subheader class="mt-4 pl-0">Administration</v-subheader>
      <v-select :disabled="disabled" :placeholder="username" :error-messages="errorMessages.userId" class="mt-2" hint="You may assign this query to other users, or leave empty to assign to yourself" persistent-hint :items="users" clearable item-value="UserId" item-text="UserName" prepend-icon="person" required label="User" v-model="formObject.userId" />
    </template>
  </v-form>
</template>
<script>
  import moment from 'moment'

  export default {
    props: {
      disabled: Boolean,
    },
    data() {
      return {
        rules: {
          required: v => !!v || 'Name is required',
        },
        formObject: {},
        initialObject: {
          id: null,
          name: '',
          userId: null,
          description: '',
          isShared: false,
          relativeDate: null,
        },
        isValid: false,
        errorMessages: {
          name: [],
          userId: [],
          description: [],
        },
      }
    },
    computed: {
      hasRelativeDates: {
        get() {
          return !!this.formObject.relativeDate
        },
        set(value) {
          if (value) {
            this.formObject.relativeDate = moment().toDate()
          } else {
            this.formObject.relativeDate = null
          }
        },
      },
      users() {
        return this.$store.getters['admin/userList']
      },
      isSomeAdmin() {
        return this.$store.getters['authenticate/isSomeAdmin']
      },
      username() {
        return this.$store.getters['authenticate/username']
      },
      currentUser() {
        return this.$store.getters['authenticate/currentUser']
      },
      userId() {
        return this.currentUser && this.currentUser.userId
      },
      queries() {
        return this.$store.getters['serviceconfigurations/configurations']
      },
      selectedUserQueries() {
        let userId = this.formObject.userId || this.userId
        return this.queries.filter(query => query.userId == userId)
      },
      selectedUser() {
        if (!this.formObject.userId) return
        return this.users.find(user => user.UserId == this.formObject.userId)
      },
    },
    watch: {
      selectedUser: {
        immediate: true,
        deep: true,
        handler(value) {
          this.$emit('update:selectedUser', value || this.currentUser)
        },
      },
      isValid(value) {
        this.$emit('update:isValid', value)
      },
      formObject(value) {
        this.$emit('update:formData', value)
      },
    },
    methods: {
      setErrorMessages(errorMessages) {
        this.errorMessages = errorMessages
      },
      clearErrorMessages() {
        Object.keys(this.errorMessages).forEach(key => {
          this.errorMessages[key] = []
        })
      },
      validate() {
        this.clearErrorMessages()
        this.$refs.form.validate()
      },
      setFormObject(data) {
        this.formObject = JSON.parse(JSON.stringify(data))
      },
      setQueryDetails(queryDetails) {
        this.formObject = {
          ...this.formObject,
          ...queryDetails,
        }
      },
    },
    created() {
      this.setFormObject(this.initialObject)
    },
  }
</script>